// Arriba de este peso el PDF del Reporte General se genera en segundo plano. El servidor tiene su
// propio tope, mas alto, y responde 422 si una descarga directa lo rebasa.
export const GENERAL_PDF_SOFT_WEIGHT = 400

// Misma cuenta que el servidor: CSV o arreglo, ids recortados, sin vacios y unicos por texto.
function countUniqueIds (ids) {
  const list = typeof ids === 'string' || typeof ids === 'number' ? String(ids).split(',') : ids
  if (!Array.isArray(list)) return 0

  const unique = new Set()
  list.forEach(id => {
    if (typeof id !== 'string' && typeof id !== 'number') return
    const text = String(id).trim()
    if (text !== '') unique.add(text)
  })

  return unique.size
}

export function estimateGeneralPdfWeight ({ locations, forms } = {}) {
  return countUniqueIds(locations) * countUniqueIds(forms)
}

export function isDirectGeneralPdfAllowed (selection, maxWeight = GENERAL_PDF_SOFT_WEIGHT) {
  return estimateGeneralPdfWeight(selection) <= maxWeight
}

// Las descargas piden responseType 'blob', asi que el JSON de un error tambien llega como Blob.
export async function readBlobErrorCode (error) {
  const data = error?.data ?? error?.response?.data
  if (!data) return null

  let body = data
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      body = JSON.parse(await data.text())
    } catch {
      return null
    }
  }

  return body?.errorCode ?? null
}
